const strings = {
    "LOGO_TEXT":"Academia <br/> Națională de Șah",
    "NAV_HOME":"Главная",
    "NAV_STUDIOS":"Студии",
    "NAV_PRACTISE":"Практика",
    "NAV_CORDINATES":"Координаты",
    "NAV_STORE":"Магазин",
    "NAV_TOURNAMENT":"Турниры",
    "BUTTON_TOP_UP_FUNDS":"Пополнить",
    "BUTTON_DONATE":"Донат",
    "TECHNICAL_SUPPORT":"Тех. поддержка",
    "LEAVE_FEEDBACK":"Оставить отзыв",
    "USER_LEVEL":"Уровень",
    "META_HOME":"Главная",
    "BTN_CONTINUE":"Продолжить",
    "BTN_EDIT":"Редактировать",
    "BTN_DELETE":"Удалить",
    "BTN_CONFIRM":"Подтвердить",
    "MONTH_1":"январь",
    "MONTH_2":"февраль",
    "MONTH_3":"март",
    "MONTH_4":"апрель",
    "MONTH_5":"май",
    "MONTH_6":"июнь",
    "MONTH_7":"июль",
    "MONTH_8":"август",
    "MONTH_9":"сентябрь",
    "MONTH_10":"октябрь",
    "MONTH_11":"ноябрь",
    "MONTH_12":"december",
    "WK_SUN":"вс | воскресенье",
    "WK_MON":"пн | понедельник",
    "WK_TUE":"вт | вторник",
    "WK_WED":"ср | среда",
    "WK_THU":"чт | четверг",
    "WK_FRI":"пт | пятница",
    "WK_SAT":"сб | суббота",
};
export default strings